import React, { useEffect, useState } from 'react';
import { Button, Header, Icon, Segment } from 'semantic-ui-react';
import agent from '../../app/api/agent';
import useQuery from '../../app/utilities/hooks';
import { toast } from 'react-toastify';
import { router } from '../../app/router/Routes';
import { useStore } from '../../app/stores/store';
import LoginForm from './LoginForm';

function ConfirmEmail() {
    //const tokenEncoded = useQuery().get('token') as string; //'
    const usQueryTokenEncoded = useQuery().get('token') as string; //.
    //const email = useQuery().get('email') as string; //'
    const usQueryEmail = useQuery().get('email') as string; //.
    const usStore= useStore();

    const Status = {
        Verifying: 'Verifing',
        Faild: 'Failed',
        Success: 'Success',
    } 

    const[status, setStatus] = useState(Status.Verifying);

    function handleVerifyEmail() {
        agent.Account.verifyEmail(usQueryTokenEncoded, usQueryEmail).then(() => {
            setStatus(Status.Success);
            toast.success('Email has been verified, you can now login!');
            //router.navigate('./activities'); //.
            //usStore.modalStore.openModal(<LoginForm />); //'
        }).catch((error) => {
            console.log(error);
            setStatus(Status.Faild);
        });
    }

    function handleResendEmailConfirmationLink() {
        agent.Account.resendEmailConfirmationLink(usQueryEmail).then(() => {
            toast.success('Verivication email resent - please check your email!');
        }).catch(error => console.log(error));
    }

    useEffect(() => {
        handleVerifyEmail();
    }, [ 
        usQueryTokenEncoded, usQueryEmail, Status.Success, Status.Faild
        //, Status.Verifying  //' nn since we did not use it (identify) in useEffect.handleVerifyEmail()
    ])

    function getBody() {
        switch (status) {
            case Status.Verifying:
                return <p>Verifying...</p>
            case Status.Faild:
                return (
                    <div>
                        <p>Verification failed. You can try reseding the verify link to your email</p>
                        <Button content='Resend email' primary size='huge' onClick={handleResendEmailConfirmationLink} /> 
                    </div>
                )
            case Status.Success:
                return (
                    <div>
                        <p>Email has been verified - you can now login!</p>
                        <Button content='Login' primary size='huge' onClick={() =>  usStore.modalStore.openModal(<LoginForm />)} />
                    </div>
                )
        }
    }

    return (
        <>
            {/* <h1>Confirm Email</h1> */}
            {/* <Button content='Confirm Email' primary size='huge' onClick={handleVerifyEmail} /> */}

            <Segment placeholder textAlign='center'>
                <Header icon><Icon name='envelope' />Email verivication</Header>
                <Segment.Inline>
                    {getBody()}
                </Segment.Inline>
            </Segment>
        </>
    )

}

export default ConfirmEmail;

